import constants from '@/app-configs/constants'

export default [
  {
    path: '/contacts/list',
    name: 'contacts-list',
    component: () => import('@/views/contact/contacts-list/ContactsList.vue'),
    meta: {
      pageTitle: 'DEBTIA_CONTACTS',
      breadcrumb: [
        {
          text: 'DEBTIA_CONTACTS',
          active: true,
        },
      ],
      action: constants.action.permissionContactView,
      resource: constants.resource.contact,
    },
  },
  {
    path: '/contacts/edit/:id',
    name: 'contacts-edit',
    component: () => import('@/views/contact/contacts-edit/ContactEdit.vue'),
    meta: {
      action: constants.action.permissionContactEdit,
      resource: constants.resource.contact,
    },
  },
  {
    path: '/contacts/view/:id',
    name: 'contacts-view',
    component: () => import('@/views/contact/contacts-view/ContactsView.vue'),
    meta: {
      action: constants.action.permissionContactView,
      resource: constants.resource.contact,
    },
  },
  {
    path: '/contacts/add',
    name: 'contacts-add',
    component: () => import('@/views/contact/contacts-add/ContactsAdd.vue'),
    meta: {
      title: 'add contacts',
      action: constants.action.permissionContactAdd,
      resource: constants.resource.contact,
    },
  },
]
